import { render, staticRenderFns } from "./Rolling7Level2.vue?vue&type=template&id=efa3d770&scoped=true"
import script from "./Rolling7Level2.vue?vue&type=script&lang=js"
export * from "./Rolling7Level2.vue?vue&type=script&lang=js"
import style0 from "./Rolling7Level2.vue?vue&type=style&index=0&id=efa3d770&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa3d770",
  null
  
)

export default component.exports